<template>
  <div class="container text-left">
    <div class="row">
      <loading :active.sync="isLoading" :is-full-page="true" color="#4e97b2"></loading>
      <div class="col-lg-12">
        <BreadcrumbsHelper class="sn-bread" :breadcrumbs="this.Breadcrumbs" />
      </div>
    </div>
    <b-card>
      <div class="row">
        <div class="col-lg-6">
          <h1 v-if="context === 'create'" class="title">Untitled Dish</h1>
          <h1 v-else class="title">{{ dish.name }}</h1>
          <b-form-group label="Name (Required)" label-for="dishName" class="title">
            <b-form-input v-model="dish.name" id="dishName" name="name" required :state="submitted && $v.dish.name.$error ? false : null" />
            <b-form-invalid-feedback class="d-block red" id="dishName" v-if="submitted && !$v.dish.name.required">
              <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a name
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
      </div>
      <div class="row mt-5">
        <b-form-group label="Is Active" label-for="dishActive" class="col-lg-2">
          <b-form-checkbox id="dishActive" size="lg" name="dishActive" v-model="dish.is_active" value="1" unchecked-value="0" switch>Active</b-form-checkbox>
        </b-form-group>
        <b-form-group label="Is Featured" label-for="dishFeatured" class="col-lg-2">
          <b-form-checkbox id="dishFeatured" size="lg" name="dishFeatured" v-model="dish.is_featured" value="1" unchecked-value="0" switch>Featured</b-form-checkbox>
        </b-form-group>
      </div>
      <b-form-group label="Description (Required)" class="mt-5" label-for="description">
        <froala
          id="description"
          :tag="'textarea'"
          :config="config"
          v-model="dish.description"
          @input="dirty = true"
          :state="submitted && $v.dish.description.$error ? false : null"
        />
        <div class="text-right">150 words</div>
        <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.dish.description.required">
          <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a description
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Restaurants (1 is Required)" label-for="restaurants">
        <b-form-select id="restaurants" name="restaurants" multiple v-model="dish.restaurant_ids" :state="submitted && $v.dish.restaurant_ids.$error ? false : null">
          <option v-for="(res, index) in restaurantOptions" :key="index" :value="res.value">{{ res.name }} - {{ res.city }}</option>
        </b-form-select>
        <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.dish.restaurant_ids.required">
          <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />At least 1 restaurant is required
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group label="Brochure Year (Optional)" label-for="brochureYear" class="title mt-5">
        <b-form-input v-model="dish.brochure_year" id="brochureYear" name="brochureYear" @input="dirty = true" />
      </b-form-group>
      <b-form-group
        label="Cuisine Types (1 is Required)"
        id="cuisines"
        stacked
        label-for="cuisines"
        v-slot="{ ariaDescribedby }"
        class="container-fluid alertField mt-5"
        v-model="dish.cuisines"
        buttons
        :state="submitted && dish.cuisines.length < 1 ? false : null"
      >
        <b-form-row>
          <b-form-checkbox-group
            id="cuisines"
            v-model="dish.cuisines"
            :options="options"
            class="mb-4"
            :aria-describedby="ariaDescribedby"
            name="cuisines"
            style="column-count: 4"
            size="lg"
            @input="dirty = true"
            stacked
            required
          >
          </b-form-checkbox-group>
        </b-form-row>
        <b-form-invalid-feedback class="d-block red" v-if="submitted && dish.cuisines.length < 1">
          <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please select at least one cuisine
        </b-form-invalid-feedback>
      </b-form-group>
      <!--Validation Feedback Area -->
      <div class="row text-left mt-3 mb-3" style="height: 60px">
        <b-form-invalid-feedback aria-live="polite" class="ml-3 d-block red" v-if="(submitted && $v.$invalid) || (submitted && formInvalid)"
          ><font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Double check the required fields. We don't have
          everything <br />
          <span class="ml-3">we need to save the record.</span></b-form-invalid-feedback
        >
      </div>
      <!--Save-->
      <div class="row">
        <b-button id="saveDishBtn" :disabled="disableButton" class="clear pl-5 pr-5 ml-3 mb-2" @click="saveDish($event)">Save</b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import axios from 'axios';
import Loading from 'vue-loading-overlay';
import stateList from '../../assets/state-list.json';
import BreadcrumbsHelper from '../common/BreadcrumbsHelper.vue';

export default {
  components: {
    Loading,
    BreadcrumbsHelper,
  },
  data() {
    return {
      dish: {
        name: '',
        description: '',
        cuisines: [],
        brochure_year: '',
        created_at: null,
        updated_at: null,
        is_active: null,
        is_featured: null,
        restaurant_ids: [],
      },
      options: [
        { text: 'American', value: 'American' },
        { text: 'Asian', value: 'Asina' },
        { text: 'Baked Goods', value: 'Baked Goods' },
        { text: 'Barbecue', value: 'Barbecue' },
        { text: 'Beverages', value: 'Beverages' },
        { text: 'Breakfast or Brunch', value: 'Breakfast or Brunch' },
        { text: 'Burgers', value: 'Burgers' },
        { text: 'Contemporary', value: 'Contemporary' },
        { text: 'Creole', value: 'Creole' },
        { text: 'Deli', value: 'Deli' },
        { text: 'Desert', value: 'Desert' },
        { text: 'Farm to Table', value: 'Farm to Table' },
        { text: 'French', value: 'French' },
        { text: 'German', value: 'German' },
        { text: 'Greek', value: 'Greek' },
        { text: 'Italian', value: 'Italian' },
        { text: 'Latin American', value: 'Latin American' },
        { text: 'Mexican', value: 'Mexican' },
        { text: 'Other', value: 'Other' },
        { text: 'Pizza', value: 'Pizza' },
        { text: 'Pub Food', value: 'Pub Food' },
        { text: 'Seafood', value: 'Seafood' },
        { text: 'Soul Food', value: 'Soul Food' },
        { text: 'Southwestern or Tex Mex', value: 'Southwestern or Tex Mex' },
      ],
      restaurantOptions: [],
      Breadcrumbs: [
        {
          text: 'Content',
          active: true,
        },
        {
          text: 'Dishes',
          href: '/dishes',
        },
        {
          text: '',
          active: true,
        },
      ],
      submitted: false,
      stateOptions: stateList,
      loaded: false,
      context: '',
      disabled: false,
      disableButton: false,
      formInvalid: false,
      config: {
        key: `${process.env.VUE_APP_FROALA}`,
        heightMax: 150,
        toolbarButtons: ['bold', 'italic', 'underline', '|', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '-', 'insertLink', '|', 'html', '|', 'undo', 'redo'],
        events: {},
      },
      customToolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], ['code-block']],
    };
  },
  validations: {
    dish: {
      name: {
        required,
      },
      description: {
        required,
      },
      cuisines: {
        required,
      },
      restaurant_ids: {
        required,
      },
    },
  },
  props: {
    value: {
      type: Array,
    },
    dishId: String,
  },
  computed: {
    isDisabled() {
      return this.disableButton;
    },
  },
  async created() {
    try {
      this.isLoading = true;
      this.context = this.$router.currentRoute.fullPath.split('/').pop();
      await Promise.all([this.getDishDetails(), this.getRestaurants()]);
      this.$emit('dishes-loaded');
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    } finally {
      this.isLoading = false;
      this.Breadcrumbs[2].text = this.dish.name;
    }
  },
  methods: {
    async getDishDetails() {
      if (this.dishId) {
        const dishResponse = await axios.get(`${process.env.VUE_APP_API_ROOT}/misc/dishes/${this.dishId}`);
        this.dish = {
          _id: dishResponse.data._id,
          id: dishResponse.data.id,
          name: dishResponse.data.name,
          description: dishResponse.data.description,
          is_featured: dishResponse.data.is_featured,
          is_active: dishResponse.data.is_active,
          brochure_year: dishResponse.data.brochure_year,
          cuisines: dishResponse.data.cuisines,
          restaurant_ids: dishResponse.data.restaurant_ids,
        };
      }
      this.isLoading = false;
    },
    async getRestaurants() {
      if (this.$store.state.misc.restaurants && this.$store.state.misc.restaurants.length === 0) {
        await this.$store.dispatch('misc/getRestaurants');
      }
      const response = this.$store.state.misc.restaurants.locations;
      this.restaurantOptions = response.map((r) => ({ value: r._id, name: r.name, city: r.city }));
    },
    async saveDish(event) {
      event.target.innerText = 'Saving...';
      this.formInvalid = false;
      this.submitted = true;

      if (!this.dish.name) {
        this.formInvalid = true;
      }

      if (!this.dish.description) {
        this.formInvalid = true;
      }

      if (this.dish.cuisines < 1) {
        this.formInvalid = true;
      }

      if (this.dish.is_active === '0') {
        this.dish.is_featured = '0';
      }

      this.$v.$touch(); // vuelidate validate all
      if (this.formInvalid || this.$v.$invalid || this.dish.cuisines.length < 1) {
        event.target.innerText = 'Save';
        const message = 'Missing Required Fields';
        this.$bvToast.toast(message, {
          title: 'Error',
          autoHideDelay: 8000,
          appendToast: true,
        });
        this.isLoading = false;
        return;
      }

      // create context
      const url = this.dishId ? `${process.env.VUE_APP_API_ROOT}/misc/dishes/${this.dishId}` : `${process.env.VUE_APP_API_ROOT}/misc/dishes`;
      try {
        const response = await axios.post(url, { ...this.dish });
        if (response.data.success) {
          const self = this;
          this.$router.push({ name: 'dishes list' }, () => {
            setTimeout(() => {
              self.$bvToast.toast('Dish Updated', { title: 'Success', autoHideDelay: 5000, appendToast: true });
            }, 500);
          });
        } else {
          this.$bvToast.toast(`${JSON.stringify(response.data.message)}`, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      } catch (err) {
        this.$bvToast.toast('Something went wrong.', {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  border: none;
}
.card-body h1 {
  margin: 0px !important;
  line-height: 4rem;
}
div.image-desc {
  width: 60%;
  font-size: 14px;
}
.final-alert {
  padding-top: 10px;
}
.alertField {
  height: 350px;
}
.float-right {
  float: right;
}
.logo {
  height: 200px;
  margin: 30px 0px 50px;
  width: 200px;
}
.validation-message {
  position: absolute;
}
/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 18px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #acacac;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider:before {
  position: absolute;
  content: '';
  height: 29.5px;
  width: 29.5px;
  left: 0px;
  bottom: -5px;
  background-color: #f2f3f4;
  box-shadow: 0px 2px 3px #dcdcdc;
  border: solid 0.5px #e5e4e2;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
input:checked + .slider:before {
  position: absolute;
  content: '';
  height: 30px;
  width: 30px;
  left: 0px;
  bottom: -5px;
  background-color: var(--blue-900);
  box-shadow: none;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider:after {
  background-color: var(--blue-900);
}
input:checked + .slider {
  background-color: #cae7f5;
}
input:focus + .slider {
  box-shadow: 0 0 1px #2196f3;
}
input:checked + .slider:before {
  -webkit-transform: translateX(22px);
  -ms-transform: translateX(22px);
  transform: translateX(22px);
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.status {
  float: right;
  display: block;
  margin-left: -19px;
  font-size: 18px;
  margin-top: -5px;
}
</style>
